import React, { Component } from 'react';
import Header from '../../components/main.header.component';

class Bio extends Component {
  componentDidMount() {
    window.scrollTo(0,0);
  }
  render() {
    return (
      <div className="Bio">
        <Header
          props={this.props}
        />
          <div id="contact-links">
            <nav className="header-effect">
              <a href="/images/Resume.pdf" target='_blank' rel="noopener noreferrer">
                <span data-hover="Resume">Resume.</span>
              </a>
            </nav>
            <nav className="header-effect">
              <a href="mailto:&#101;&#114;&#105;&#099;&#114;&#105;&#099;&#107;&#121;&#097;&#108;&#108;&#101;&#110;&#112;&#101;&#116;&#101;&#114;&#115;&#064;&#103;&#109;&#097;&#105;&#108;&#046;&#099;&#111;&#109;">
              <span data-hover="Email">Email.</span>
              </a>
            </nav>

            <nav className="header-effect">
              <a href="https://github.com/cozpon" target='_blank' rel="noopener noreferrer">
                <span data-hover="Github">Github.</span>
              </a>
            </nav>

            <nav className="header-effect">
              <a href="https://medium.com/@rickyapeters" target='_blank' rel="noopener noreferrer">
                <span data-hover="Medium">Medium.</span>
              </a>
            </nav>


            <nav className="header-effect">
              <a href="https://www.linkedin.com/in/ricky-peters/" target='_blank' rel="noopener noreferrer">
                <span data-hover="LinkedIn">LinkedIn.</span>
              </a>
            </nav>
          </div>
          <div className="bio-text">
            Big fan of React,<br />
            Javascript Developer,<br />
            and, Haiku expert.
            <br />
            <br />
            <hr />
            <div id="bio-front-end">
              <h2>Front-end</h2>
              Javascript, ReactJS (with Redux), React-Native, CSS3 (SASS), ES6, Ruby + Rails
            </div>
            <div id="bio-back-end">
              <h2>Back-end</h2>
              Node.js, PostgreSQL, Express.js, API integration, PHP, Sequelize
            </div>
            <div id="bio-cms-end">
              <h2>CMS</h2>
              CraftCMS3, Wordpress, ExpressionEngine
            </div>
            <br />
            <br />
            <hr />
            <br />
            Currently living in San Jose, CA.
            <br />
            <br />
          </div>
        </div>
    );
  }
}

export default Bio;

